import { gql } from '@apollo/client'
import { BodyText, Button, Col, Heading, Row } from '@farol-ds/react'
import Link from 'next/link'

import { useModalContext } from '../context'
import { PixUpgradeLock_OfferLockDataFragment } from './__generated__/pix-upgrade-lock.graphql'
import styles from './pix-upgrade-lock.module.scss'

export interface PixUpgradeLockContentProps {
  offerLockData: PixUpgradeLock_OfferLockDataFragment
}

export function PixUpgradeLockContent({ offerLockData }: PixUpgradeLockContentProps) {
  const { setOpen } = useModalContext()

  const { header, body } = offerLockData || {}
  const { title = '', subtitle = '' } = header || {}
  const [card] = body?.cards || []

  return (
    <Row>
      <Col xs={12}>
        <Heading className={styles.pixUpgradeLockHeading} size="lg" asChild>
          <h3>{title}</h3>
        </Heading>

        <BodyText className={styles.pixUpgradeLockSubtitle}>{subtitle}</BodyText>

        <div className={styles.pixUpgradeLockButtons}>
          <Button asChild>
            <Link href={card?.link?.url || ''}>{card?.link?.label}</Link>
          </Button>
          <Button kind="primary" onClick={() => setOpen(false)}>
            {card?.button?.label}
          </Button>
        </div>
      </Col>
    </Row>
  )
}

PixUpgradeLockContent.fragments = {
  offerLockData: gql`
    fragment PixUpgradeLockContent_offerLockData on OfferLockData {
      header {
        title
        subtitle
      }
      body {
        cards {
          link {
            label
            url
          }
          button {
            label
          }
          lockEventProperties {
            pid
            feature
            current_plan
            next_plan
            plan_price
            modal_type
            experiment_id
            app_id
            from_component
            resource_id
            parent_resource_id
          }
        }
      }
    }
  `,
}
